import React from 'react';
import {humanize, pluralize} from 'inflection';
import {useMediaQuery} from '@mui/material';
import {makeStyles} from '@mui/styles';
import DefaultIcon from '@mui/icons-material/ViewList';
import {MenuItemLink, useResourceDefinitions, useSidebarState, useTranslate} from 'react-admin';
import classnames from 'classnames';
import Divider from '@mui/material/Divider';
import finadoLogo from './images/logo.jpg'

const useStyles = makeStyles( theme=> ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        backgroundColor: theme.palette.primary.main,
        height: '100%',
        overflowX: 'hidden',
        '& .RaMenuItemLink-active': {
            backgroundColor: 'rgba(255,255,255,0.15)',
        },
    },
}));

const translatedResourceName = (resource, translate) =>
    translate(`resources.${resource.name}.name`, {
        smart_count: 2,
        _:
            resource.options && resource.options.label
                ? translate(resource.options.label, {
                    smart_count: 2,
                    _: resource.options.label,
                })
                : humanize(pluralize(resource.name)),
    });

const Menu = ({
                  classes: classesOverride,
                  className,
                  dense,
                  ...rest
              }) => {
    const translate = useTranslate();
    const classes = useStyles({ classes: classesOverride });
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const [open] = useSidebarState();
    const resourcesDefinitions = useResourceDefinitions();
    const resources = Object.keys(resourcesDefinitions).map(name => resourcesDefinitions[name]);

    return (
        <div className={classnames(classes.main, className)} {...rest}>
 <>
    {!isXSmall && !dense && <img style={{ width: '240px', maxWidth: '100%', display: 'block' }} src={finadoLogo} alt="Finado"/> }
</>
              <Divider style={{marginBottom:20}}/>
            {resources
                .filter(r => r.hasList)
                .map(resource => (
                    <MenuItemLink
                        sx={{ '&, & *': { color: '#FFF' } }}
                        key={resource.name}
                        to={`/${resource.name}`}
                        primaryText={translatedResourceName(
                            resource,
                            translate
                        )}
                        leftIcon={
                            resource.icon ? <resource.icon fontSize='large' /> : <DefaultIcon fontSize='large' />
                        }
                        dense={dense}
                        sidebarIsOpen={open}
                    />
                ))}

        </div>
    );
};


export default  Menu;
